import { render, staticRenderFns } from "./ocrUpd.vue?vue&type=template&id=7951c7ad"
import script from "./ocrUpd.vue?vue&type=script&lang=js"
export * from "./ocrUpd.vue?vue&type=script&lang=js"
import style0 from "./ocrUpd.vue?vue&type=style&index=0&id=7951c7ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports